var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type && _vm.text)?_c('span',{staticClass:"tag",style:(_vm.borderStyle)},[_c('img',{attrs:{"src":_vm.icon,"alt":""}}),_c('span',{staticClass:"text",style:(_vm.colorStyle)},[_vm._v(_vm._s(_vm.text))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }